import { useBrandsAndProducts } from '@terminal/react-query-hooks/knowledge-graph/useBrandsAndProducts';
import {
  useCompanyCompetitorWithThemes,
  useCompanyCountryExposure,
  useCompanyRegionExposure,
  useCompanyTheme,
} from '@terminal/react-query-hooks/knowledge-graph/useKnowledgeGraph';

interface UseKnowledgeGraphDataParams {
  entityTag: string;
}

export const useKnowledgeGraphData = ({
  entityTag,
}: UseKnowledgeGraphDataParams) => {
  const { data: themeData, isFetching: isThemeFetching } = useCompanyTheme({
    entityTag,
  });

  const {
    data: brandsAndProductsData,
    isFetching: isBrandsAndProductsFetching,
  } = useBrandsAndProducts(entityTag);

  const { data: competitorsData, isFetching: isCompetitorsFetching } =
    useCompanyCompetitorWithThemes({
      entityTag,
    });

  const { data: countryExposureData, isFetching: isCountryExposureFetching } =
    useCompanyCountryExposure({
      entityTag,
    });

  const { data: regionExposureData, isFetching: isRegionExposureFetching } =
    useCompanyRegionExposure({
      entityTag,
    });

  const hasThemeData = !!themeData?.length;
  const hasCompetitorsData = !!competitorsData?.length;
  const hasGeographicData =
    !!countryExposureData?.length || !!regionExposureData?.length;

  const isFetching =
    isThemeFetching ||
    isBrandsAndProductsFetching ||
    isCompetitorsFetching ||
    isCountryExposureFetching ||
    isRegionExposureFetching;

  return {
    hasThemeData,
    hasBrandsAndProductsData: !!brandsAndProductsData?.length,
    hasCompetitorsData,
    hasGeographicData,
    isFetching,
  };
};
